import { Document } from '@/interfaces/requirement';
import { alLeastOneDateEndMustBeNotUndefined } from '@/validators/alLeastOneDateEndMustBeNotUndefined';
import { mustHaveOneRecord } from '@/validators/mustHaveOneRecord';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'app-modify-dates-form',
  templateUrl: './modify-dates-form.component.html',
  styleUrls: ['./modify-dates-form.component.css'],
})
export class ModifyDatesFormComponent implements OnInit {

  @Input() documents: Document[] = [];
  @Input() requirementId: number = 0;
  @Input() driverMdmid: string = '';
  @Input() driverIsEmployee: boolean = false;
  @Input() assetId: number = 0;

  @Output() modifyDates = new EventEmitter();

  documentFormArray = new FormArray([], [mustHaveOneRecord(), alLeastOneDateEndMustBeNotUndefined()]);

  constructor() { }

  ngOnInit(): void {

  }

  onModifyDates() {
    this.modifyDates.emit(this.documentFormArray.value);
  }
}
